(function () {
  function productString(key) {
    return ((window.Axiom && window.Axiom.productStrings && window.Axiom.productStrings[key]) || '').toString();
  }

  function initAxiomProductB2B(root) {
    var scope = root && root.querySelector ? root : document;
    var productRoot = scope.querySelector('[data-product-root]') || document.querySelector('[data-product-root]');
    if (!productRoot || productRoot.dataset.productB2bInitialized === 'true') return;
    productRoot.dataset.productB2bInitialized = 'true';

    var configEl = document.querySelector('[data-product-b2b-config]');
    if (!configEl) return;

    var config = {};
    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      return;
    }

    function money(cents) {
      return window.Axiom.formatMoney(cents);
    }

    function getVariantData(variantId) {
      if (!config.variants) return null;
      return config.variants[String(variantId)] || null;
    }

    productRoot.addEventListener('product:variant-state', function (event) {
      var detail = event.detail || {};
      if (String(detail.productId) !== String(config.productId) || !detail.variantId || !detail.variantState) return;
      config.variants = config.variants || {};
      config.variants[String(detail.variantId)] = detail.variantState;
    });

    function getSortedPriceBreaks(variantData) {
      if (!variantData || !variantData.priceBreaks) return [];
      return variantData.priceBreaks.slice().sort(function (a, b) {
        return a.minimumQuantity - b.minimumQuantity;
      });
    }

    function hasRules(variantData) {
      if (!variantData || !variantData.quantityRule) return false;
      return variantData.quantityRule.min > 1 || variantData.quantityRule.increment > 1 || variantData.quantityRule.max !== null;
    }

    function hasBreaks(variantData) {
      return Boolean(variantData && variantData.priceBreaks && variantData.priceBreaks.length);
    }

    function ruleMessage(template, quantity) {
      return String(template || '').replace('[quantity]', quantity);
    }

    function getEffectivePrice(variantId, quantity) {
      var variantData = getVariantData(variantId);
      if (!variantData) return { cents: 0, formatted: money(0) };
      var price = variantData.price;
      getSortedPriceBreaks(variantData).forEach(function (priceBreak) {
        if (quantity >= priceBreak.minimumQuantity) {
          price = priceBreak.price;
        }
      });
      return {
        cents: price,
        formatted: money(price)
      };
    }

    function renderQuantityPricing(variantId) {
      var container = document.querySelector('[data-quantity-pricing]');
      if (!config.isB2BCustomer || config.enableQuantityPricing !== true) return;
      var variantData = getVariantData(variantId);
      if (!variantData) {
        if (container) container.hidden = true;
        return;
      }

      syncQuantityPricingState(variantId);
      if (!container) return;

      var ruleList = container.querySelector('[data-quantity-rule-list]');
      var breakList = container.querySelector('[data-price-breaks]');
      var ruleItems = [];

      if (variantData.quantityRule.min > 1) {
        ruleItems.push('<li>' + ruleMessage(config.strings.minimumRule, variantData.quantityRule.min) + '</li>');
      }
      if (variantData.quantityRule.max !== null) {
        ruleItems.push('<li>' + ruleMessage(config.strings.maximumRule, variantData.quantityRule.max) + '</li>');
      }
      if (variantData.quantityRule.increment > 1) {
        ruleItems.push('<li>' + ruleMessage(config.strings.incrementRule, variantData.quantityRule.increment) + '</li>');
      }

      if (ruleList) {
        ruleList.hidden = ruleItems.length === 0;
        var rulesContainer = ruleList.querySelector('.product-b2b-pricing__rule-items');
        if (rulesContainer) rulesContainer.innerHTML = ruleItems.join('');
      }

      if (breakList) {
        var breaks = getSortedPriceBreaks(variantData);
        breakList.hidden = breaks.length === 0;
        var breakContainer = breakList.querySelector('.product-b2b-pricing__break-list');
        if (breakContainer) {
          var items = [
            '<div class="product-b2b-pricing__break product-b2b-pricing__break--base" data-price-break-row data-break-min="' +
              (variantData.quantityRule.min || 1) +
              '"><span>' +
              (variantData.quantityRule.min || 1) +
              '+</span><span>' +
              String(config.strings.quantityPriceEach || '[price]').replace('[price]', variantData.priceFormatted) +
            '</span></div>'
          ];
          breaks.forEach(function (priceBreak) {
            items.push(
              '<div class="product-b2b-pricing__break" data-price-break-row data-break-min="' +
                priceBreak.minimumQuantity +
                '"><span>' +
                priceBreak.minimumQuantity +
                '+</span><span>' +
                String(config.strings.quantityPriceEach || '[price]').replace('[price]', priceBreak.priceFormatted) +
              '</span></div>'
            );
          });
          breakContainer.innerHTML = items.join('');
        }
      }

      container.hidden = !(hasRules(variantData) || hasBreaks(variantData) || config.quantityPricingConfigured);
      syncQuantityPricingState(variantId);
    }

    function getMainQuantityInput() {
      return document.querySelector('[data-qty-input]');
    }

    function getCurrentPricingQuantity(variantId, explicitQuantity) {
      var variantData = getVariantData(variantId);
      if (!variantData) return 0;
      var quantityInput = getMainQuantityInput();
      var selectedQty = explicitQuantity !== undefined && explicitQuantity !== null
        ? parseInt(explicitQuantity, 10)
        : parseInt(quantityInput && quantityInput.value ? quantityInput.value : variantData.quantityRule.min || 1, 10);
      if (!Number.isFinite(selectedQty) || selectedQty < 0) selectedQty = parseInt((variantData.quantityRule && variantData.quantityRule.min) || 1, 10);
      return Math.max(0, selectedQty);
    }

    function syncQuantityPricingState(variantId, explicitQuantity) {
      var container = document.querySelector('[data-quantity-pricing]');
      var variantData = getVariantData(variantId);
      if (!variantData) return;
      var pricingQty = getCurrentPricingQuantity(variantId, explicitQuantity);
      var effectivePrice = getEffectivePrice(variantId, pricingQty);
      document.querySelectorAll('[data-quantity-pricing-current]').forEach(function (currentPrice) {
        currentPrice.textContent = String(config.strings.quantityPriceAtEach || '[price]').replace('[price]', effectivePrice.formatted);
      });

      if (!container || container.hidden) return;

      var activeBreakMin = parseInt((variantData.quantityRule && variantData.quantityRule.min) || 1, 10) || 1;
      getSortedPriceBreaks(variantData).forEach(function (priceBreak) {
        if (pricingQty >= priceBreak.minimumQuantity) activeBreakMin = priceBreak.minimumQuantity;
      });

      container.querySelectorAll('[data-price-break-row]').forEach(function (row) {
        row.classList.toggle('is-active', parseInt(row.dataset.breakMin || '0', 10) === activeBreakMin);
      });
    }

    function getStandardCartLines(cart) {
      return window.AxiomStandardStorefront && typeof window.AxiomStandardStorefront.getCartLines === 'function'
        ? window.AxiomStandardStorefront.getCartLines(cart)
        : [];
    }

    function getLineVariantId(line) {
      var merchandise = line && line.merchandise;
      var id = merchandise && merchandise.id ? String(merchandise.id) : '';
      return id.replace(/^gid:\/\/shopify\/ProductVariant\//, '');
    }

    function getCartQty(cart, variantId) {
      var lines = getStandardCartLines(cart);
      return lines.reduce(function (sum, line) {
        return sum + (String(getLineVariantId(line)) === String(variantId) ? Number(line.quantity || 0) : 0);
      }, 0);
    }

    function getProductTotals(cart) {
      var variantIds = Object.keys(config.variants || {});
      var lines = getStandardCartLines(cart);
      return lines.reduce(function (acc, line) {
        var variantId = String(getLineVariantId(line));
        var quantity = Number(line.quantity || 0);
        if (variantIds.indexOf(variantId) === -1) return acc;
        acc.quantity += quantity;
        acc.total += getEffectivePrice(variantId, quantity).cents * quantity;
        return acc;
      }, { quantity: 0, total: 0 });
    }

    function syncQuickOrderRow(row, quantity, options) {
      if (!row) return;
      options = options || {};
      var variantId = row.dataset.variantId;
      var input = row.querySelector('[data-qol-input]');
      var unitPrice = row.querySelector('[data-qol-unit-price]');
      var lineTotal = row.querySelector('[data-qol-line-total]');
      var price = getEffectivePrice(variantId, quantity);
      if (input && document.activeElement !== input) input.value = quantity;
      if (unitPrice) unitPrice.textContent = String(config.strings.quickOrderEach || '[price]').replace('[price]', price.formatted);
      if (lineTotal) lineTotal.textContent = money(price.cents * quantity);
      if (!options.keepUpdating) row.classList.toggle('is-updating', false);
    }

    function syncQuickOrderSummary(list, cart) {
      if (!list) return;
      var totals = getProductTotals(cart);
      var itemsEl = list.querySelector('[data-qol-items]');
      var totalEl = list.querySelector('[data-qol-total]');
      var clearBtn = list.querySelector('[data-qol-clear]');
      if (itemsEl) itemsEl.textContent = String(config.strings.quickOrderItems || '[count]').replace('[count]', totals.quantity);
      if (totalEl) totalEl.textContent = money(totals.total);
      if (clearBtn) clearBtn.hidden = totals.quantity === 0;
    }

    function setQuickOrderFeedback(list, key, type) {
      if (!list) return;
      var message = list.querySelector('[data-qol-message]');
      var error = list.querySelector('[data-qol-error]');
      if (message) message.textContent = '';
      if (error) error.textContent = '';
      if (type === 'error' && error) {
        error.textContent = key || config.strings.quickOrderError || '';
      }
      if (type === 'message' && message) {
        message.textContent = key || config.strings.quickOrderUpdated || '';
      }
    }

    // One quick order request at a time. Each one diffs against the cart read
    // from Shopify (cart.js) when it starts, never against an earlier snapshot,
    // so a second change cannot add the same quantity again.
    var quickOrderQueue = Promise.resolve();

    function updateQuickOrderCart(list, updates, options) {
      var run = quickOrderQueue.then(function () {
        return sendQuickOrderUpdate(list, updates, options);
      });
      quickOrderQueue = run.catch(function () {});
      return run;
    }

    function sendQuickOrderUpdate(list, updates, options) {
      options = options || {};
      var rows = list.querySelectorAll('[data-qol-row]');
      rows.forEach(function (row) {
        if (updates[row.dataset.variantId] !== undefined) row.classList.add('is-updating');
      });

      if (!window.AxiomStandardStorefront || typeof window.AxiomStandardStorefront.fetchCart !== 'function' || typeof window.AxiomStandardStorefront.updateCart !== 'function') {
        return Promise.reject(new Error(config.strings.quickOrderError || productString('quickOrderError')));
      }

      return window.AxiomStandardStorefront.fetchCart()
        .then(function (currentCart) {
          var lines = [];
          var currentLines = getStandardCartLines(currentCart);
          Object.keys(updates).forEach(function (variantId) {
            var targetQty = Math.max(0, parseInt(updates[variantId], 10) || 0);
            var matchingLines = currentLines.filter(function (line) {
              return String(getLineVariantId(line)) === String(variantId);
            });
            if (matchingLines.length) {
              matchingLines.forEach(function (line, index) {
                lines.push({ id: line.id, quantity: index === 0 ? targetQty : 0 });
              });
            } else if (targetQty > 0) {
              lines.push({ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: targetQty });
            }
          });
          if (!lines.length) return { cart: currentCart };
          return window.AxiomStandardStorefront.updateCart({ lines: lines }, { target: list, context: 'cart', source: 'product-b2b' });
        })
        .then(function (result) {
          var cart = result.cart;
          if (!options.skipRowSync) {
            rows.forEach(function (row) {
              var cartQty = getCartQty(cart, row.dataset.variantId);
              syncQuickOrderRow(row, cartQty);
            });
          }
          if (!options.skipSummarySync) syncQuickOrderSummary(list, cart);
          if (window.Axiom && typeof window.Axiom.updateCartCount === 'function') {
            window.Axiom.updateCartCount(window.AxiomStandardStorefront.getCartTotalQuantity(cart));
          }
          setQuickOrderFeedback(list, config.strings.quickOrderUpdated, 'message');
          return cart;
        })
        .catch(function (error) {
          rows.forEach(function (row) { row.classList.remove('is-updating'); });
          setQuickOrderFeedback(list, error && error.message ? error.message : config.strings.quickOrderError, 'error');
        });
    }

    function normalizeQuickOrderQty(rawValue, variantId, allowZero) {
      var variantData = getVariantData(variantId);
      if (!variantData) return 0;
      var rule = variantData.quantityRule || {};
      var min = parseInt(rule.min || 1, 10);
      var step = parseInt(rule.increment || 1, 10);
      var max = rule.max === null || rule.max === undefined ? null : parseInt(rule.max, 10);
      var value = parseInt(rawValue, 10);
      if (!Number.isFinite(value)) value = allowZero ? 0 : min;
      if (allowZero && value <= 0) return 0;
      if (value < min) value = min;
      if (max !== null && value > max) value = max;
      if (value > min) {
        var remainder = (value - min) % step;
        if (remainder !== 0) value -= remainder;
      }
      if (max !== null && value > max) value = max;
      return Math.max(0, value);
    }

    function initQuickOrderList() {
      var list = document.querySelector('[data-quick-order-list]');
      if (!list || !config.isB2BCustomer || config.enableQuickOrderList !== true) return;

      var debounceTimers = new Map();
      var desiredQuantities = new Map();
      var toggle = list.querySelector('[data-quick-order-toggle]');
      var content = list.querySelector('[data-quick-order-content]');

      if (toggle && content && toggle.dataset.quickOrderToggleBound !== 'true') {
        toggle.dataset.quickOrderToggleBound = 'true';
        toggle.addEventListener('click', function () {
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          content.hidden = expanded;
          list.classList.toggle('is-expanded', !expanded);
        });
      }

      function getQuickOrderRow(variantId) {
        return list.querySelector('[data-qol-row][data-variant-id="' + variantId + '"]');
      }

      function queueUpdate(variantId, nextQty) {
        desiredQuantities.set(String(variantId), nextQty);
        var row = getQuickOrderRow(variantId);
        if (row) {
          row.classList.add('is-updating');
          syncQuickOrderRow(row, nextQty, { keepUpdating: true });
        }

        if (debounceTimers.has(variantId)) window.clearTimeout(debounceTimers.get(variantId));
        debounceTimers.set(variantId, window.setTimeout(function () {
          var updates = {};
          updates[variantId] = nextQty;
          updateQuickOrderCart(list, updates, { skipRowSync: true, skipSummarySync: true }).then(function (cart) {
            if (!cart) return;
            var hasPendingDesired = false;
            list.querySelectorAll('[data-qol-row]').forEach(function (row) {
              var rowVariantId = row.dataset.variantId;
              var cartQty = getCartQty(cart, rowVariantId);
              var desiredQty = desiredQuantities.get(String(rowVariantId));
              if (desiredQty !== undefined && desiredQty !== cartQty) {
                hasPendingDesired = true;
                syncQuickOrderRow(row, desiredQty, { keepUpdating: true });
                return;
              }
              desiredQuantities.delete(String(rowVariantId));
              syncQuickOrderRow(row, cartQty);
            });
            if (!hasPendingDesired) syncQuickOrderSummary(list, cart);
          });
          debounceTimers.delete(variantId);
        }, 160));
      }

      list.querySelectorAll('[data-qol-row]').forEach(function (row) {
        var variantId = row.dataset.variantId;
        var input = row.querySelector('[data-qol-input]');
        var minus = row.querySelector('[data-qol-minus]');
        var plus = row.querySelector('[data-qol-plus]');
        if (!input) return;

        function syncButtons() {
          var variantData = getVariantData(variantId);
          if (!variantData) return;
          var currentQty = parseInt(input.value || '0', 10) || 0;
          var max = variantData.quantityRule.max;
          if (minus) minus.disabled = currentQty <= 0;
          if (plus && max !== null && max !== undefined) plus.disabled = currentQty >= max;
        }

        if (minus) {
          minus.addEventListener('click', function () {
            var variantData = getVariantData(variantId);
            var step = parseInt((variantData && variantData.quantityRule.increment) || 1, 10);
            var currentQty = parseInt(input.value || '0', 10) || 0;
            var nextQty = currentQty - step;
            var min = parseInt((variantData && variantData.quantityRule.min) || 1, 10);
            if (nextQty < min) nextQty = currentQty > min ? min : 0;
            nextQty = normalizeQuickOrderQty(nextQty, variantId, true);
            input.value = nextQty;
            syncButtons();
            queueUpdate(variantId, nextQty);
          });
        }

        if (plus) {
          plus.addEventListener('click', function () {
            var variantData = getVariantData(variantId);
            var step = parseInt((variantData && variantData.quantityRule.increment) || 1, 10);
            var min = parseInt((variantData && variantData.quantityRule.min) || 1, 10);
            var currentQty = parseInt(input.value || '0', 10) || 0;
            var nextQty = currentQty === 0 ? min : currentQty + step;
            nextQty = normalizeQuickOrderQty(nextQty, variantId, false);
            input.value = nextQty;
            syncButtons();
            queueUpdate(variantId, nextQty);
          });
        }

        input.addEventListener('change', function () {
          var nextQty = normalizeQuickOrderQty(input.value, variantId, true);
          input.value = nextQty;
          syncButtons();
          queueUpdate(variantId, nextQty);
        });

        syncButtons();
      });

      var clearButton = list.querySelector('[data-qol-clear]');
      if (clearButton) {
        clearButton.addEventListener('click', function () {
          var updates = {};
          desiredQuantities.clear();
          debounceTimers.forEach(function (timer) { window.clearTimeout(timer); });
          debounceTimers.clear();
          list.querySelectorAll('[data-qol-row]').forEach(function (row) {
            updates[row.dataset.variantId] = 0;
            var input = row.querySelector('[data-qol-input]');
            if (input) input.value = 0;
          });
          updateQuickOrderCart(list, updates);
        });
      }
    }

    renderQuantityPricing((document.querySelector('[data-variant-id]') || {}).value);
    initQuickOrderList();

    // A section re-render initializes a new product root: drop the old one's listeners.
    if (documentListeners) documentListeners.abort();
    documentListeners = new AbortController();

    document.addEventListener('shopify:product:select', function (event) {
      if (!event.promise) return;
      // Quick view, Featured product and other forms on the page select their own products.
      var selectedProductId = event.product && event.product.id ? String(event.product.id).split('/').pop() : '';
      if (selectedProductId !== String(config.productId)) return;
      event.promise.then(function (result) {
        // Standard events carry gid://shopify/ProductVariant/<id>; the pricing data is keyed by the number.
        if (result && result.variant) renderQuantityPricing(String(result.variant.id).split('/').pop());
      }).catch(function () {});
    }, { signal: documentListeners.signal });

    document.addEventListener('product:quantity:change', function (event) {
      if (!event.detail || !event.detail.variantId || !getVariantData(event.detail.variantId)) return;
      syncQuantityPricingState(event.detail.variantId, event.detail.quantity);
    }, { signal: documentListeners.signal });
  }

  var documentListeners = null;

  initAxiomProductB2B(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAxiomProductB2B(event.target);
  });
})();
